import React, { useEffect, useState } from "react";
import {
  ArrowRight,
  CheckCircle,
  Phone,
  Mail,
  MapPin,
  Calendar,
  Sparkles,
  Star,
  Shield,
  Brush,
  Clock,
} from "lucide-react";

import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import image1 from "../assets/post.jpg";
export const BookFreeSiteVisitSection = () => {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    pincode: "",
    email: "",
    whatsappUpdates: false,
    userType: "",
    selectedLocation: "",
  });

  const [showToast, setShowToast] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [pincodeData, setPincodeData] = useState([]);
  const [message, setMessage] = useState("");

  const businessPhoneNumber = "+919427986568";

  // ================= SUBMIT =================

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsLoading(true);

    try {
      const response = await fetch(
        `https://webadmin.rigve.com/api/save_contact?name=${encodeURIComponent(
          formData.name,
        )}&phone=${encodeURIComponent(
          formData.mobile,
        )}&email=${encodeURIComponent(
          formData.email || "-",
        )}&msg=${encodeURIComponent(message)}`,
      );

      if (response.ok) {
        setShowToast(true);

        const whatsappMessage = `
Booking Appointment

Name: ${formData.name}
Mobile: ${formData.mobile}
Email: ${formData.email}

${message}
`;

        setTimeout(() => {
          setShowToast(false);

          window.location.href = `https://wa.me/${businessPhoneNumber.replace(
            "+",
            "",
          )}?text=${encodeURIComponent(whatsappMessage)}`;
        }, 1500);

        setFormData({
          name: "",
          mobile: "",
          pincode: "",
          email: "",
          whatsappUpdates: false,
          userType: "",
          selectedLocation: "",
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  // ================= FETCH PINCODE =================

  useEffect(() => {
    const fetchPincodeData = async () => {
      if (formData.pincode.length === 6) {
        try {
          const response = await fetch(
            `https://api.postalpincode.in/pincode/${formData.pincode}`,
          );

          const result = await response.json();

          if (result[0].Status === "Success") {
            setPincodeData(result[0].PostOffice);
          } else {
            setPincodeData([]);
          }
        } catch (error) {
          console.log(error);
          setPincodeData([]);
        }
      }
    };

    fetchPincodeData();
  }, [formData.pincode]);

  // ================= MESSAGE =================

  useEffect(() => {
    const selectedLocation = pincodeData.find(
      (location) => location.Name === formData.selectedLocation,
    );

    setMessage(`
WhatsApp Updates: ${formData.whatsappUpdates}
User Type: ${formData.userType}
Pincode: ${formData.pincode}
Location: ${selectedLocation?.Name || "Unknown"}
District: ${selectedLocation?.District || "Unknown"}
State: ${selectedLocation?.State || "Unknown"}
Country: ${selectedLocation?.Country || "Unknown"}
`);
  }, [
    pincodeData,
    formData.whatsappUpdates,
    formData.userType,
    formData.pincode,
    formData.selectedLocation,
  ]);

  return (
    <div className="overflow-hidden bg-white">
      {/* ================================================= */}
      {/* HERO SECTION */}
      {/* ================================================= */}

      <section className="relative flex items-center bg-gradient-to-br from-orange-50 via-white to-orange-100 py-10">
        {/* Blur Effects */}
        <div className="absolute top-0 left-0 w-72 h-72 bg-orange-400/20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-orange-500/20 rounded-full blur-3xl"></div>
        <div className="max-w-7xl mx-auto px-4">
          {" "}
          <div className="flex flex-col lg:flex-row items-center gap-8">
            {/* IMAGE SIDE: Hidden on mobile (xs), visible on tablet/desktop (md+) */}
            <div className="w-full lg:w-1/2">
              <img
                src={image1}
                alt="Site Visit"
                className="w-full h-full object-cover rounded-2xl shadow-xl"
              />
            </div>

            {/* FORM SIDE: Full width on mobile, 50% width on tablet+ */}
            <div className="w-full lg:w-1/2">
              {/* RIGHT SIDE FORM */}
              <div className="relative">
                {/* FORM */}
                <div className="bg-white/90 backdrop-blur-xl p-6 rounded-2xl shadow-2xl border border-white relative z-10">
                  <div className="mb-5">
                    <div className="flex items-center gap-3 mb-3">
                      <Calendar className="text-orange-500" />

                      <h5 className="text-lg font-bold text-gray-900">
                        Appointment Form
                      </h5>
                    </div>

                    <p className="text-gray-500 text-base">
                      Fill in your details and our team will contact you
                      shortly.
                    </p>
                  </div>

                  {/* SUCCESS */}
                  {showToast && (
                    <div className="bg-green-100 border border-green-300 text-green-700 rounded-xl px-4 py-3 mb-5">
                      Appointment booked successfully!
                    </div>
                  )}

                  <form onSubmit={handleSubmit} className="space-y-5">
                    <div className="flex flex-col md:flex-row items-center gap-4">
                      {/* NAME */}
                      <input
                        type="text"
                        required
                        placeholder="Enter your name"
                        value={formData.name}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            name: e.target.value,
                          })
                        }
                        className="w-full h-14 text-sm px-5 rounded-2xl border border-gray-300 focus:ring-4 focus:ring-orange-100 focus:border-orange-500 outline-none"
                      />
                      {/* MOBILE */}
                      <input
                        type="tel"
                        required
                        pattern="[0-9]{10}"
                        placeholder="Enter mobile number"
                        value={formData.mobile}
                        onChange={(e) => {
                          const value = e.target.value.replace(/\D/g, "");

                          if (value.length <= 10) {
                            setFormData({
                              ...formData,
                              mobile: value,
                            });
                          }
                        }}
                        className="w-full h-14 text-sm px-5 rounded-2xl border border-gray-300 focus:ring-4 focus:ring-orange-100 focus:border-orange-500 outline-none"
                      />
                    </div>
                    <div className="flex flex-col col-span-2 md:flex-row items-center gap-4">
                      {/* EMAIL */}
                      <input
                        type="email"
                        placeholder="Enter your email"
                        value={formData.email}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            email: e.target.value,
                          })
                        }
                        className="w-full h-14 text-sm px-5 rounded-2xl border border-gray-300 focus:ring-4 focus:ring-orange-100 focus:border-orange-500 outline-none"
                      />
                      {/* PINCODE */}
                      <input
                        type="text"
                        required
                        pattern="[0-9]{6}"
                        placeholder="Enter pincode"
                        value={formData.pincode}
                        onChange={(e) => {
                          const value = e.target.value.replace(/\D/g, "");

                          if (value.length <= 6) {
                            setFormData({
                              ...formData,
                              pincode: value,
                              selectedLocation: "",
                            });
                          }
                        }}
                        className="w-full h-14 text-sm px-5 rounded-2xl border border-gray-300 focus:ring-4 focus:ring-orange-100 focus:border-orange-500 outline-none"
                      />
                    </div>
                    {/* LOCATION */}
                    {formData.pincode.length === 6 &&
                      pincodeData.length > 0 && (
                        <Select
                          displayEmpty
                          value={formData.selectedLocation}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              selectedLocation: e.target.value,
                            })
                          }
                          sx={{
                            height: "50px",
                            borderRadius: "16px",
                          }}
                          className="w-full text-sm"
                        >
                          <MenuItem value="" disabled>
                            Select Location
                          </MenuItem>

                          {pincodeData.map((location, index) => (
                            <MenuItem key={index} value={location.Name}>
                              {location.Name}
                            </MenuItem>
                          ))}
                        </Select>
                      )}
                    {/* CHECKBOX */}
                    <label className="flex items-center gap-3 cursor-pointer">
                      <input
                        type="checkbox"
                        checked={formData.whatsappUpdates}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            whatsappUpdates: e.target.checked,
                          })
                        }
                        className="w-5 h-5 accent-orange-500"
                      />

                      <span className="text-gray-700">
                        Update me on WhatsApp
                      </span>
                    </label>
                    {/* RADIO */}
                    <div className="">
                      {/* <p className="font-semibold text-gray-800 mb-2">
                        Select User Type
                      </p> */}

                      <FormControl className="w-full">
                        <RadioGroup
                          className="grid grid-cols-1 sm:grid-cols-2 w-full"
                          value={formData.userType}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              userType: e.target.value,
                            })
                          }
                        >
                          <FormControlLabel
                            value="Architect"
                            control={<Radio />}
                            label="Architect / Interior Designer"
                          />

                          <FormControlLabel
                            value="Homeowner"
                            control={<Radio />}
                            label="Homeowner / Client"
                          />

                          <FormControlLabel
                            value="Dealer"
                            control={<Radio />}
                            label="Dealership / Distribution"
                          />
                        </RadioGroup>
                      </FormControl>
                    </div>
                    {/* BUTTON */}
                    <button
                      type="submit"
                      disabled={isLoading}
                      className="w-full h-12 bg-orange-500 hover:bg-orange-600 text-white rounded-2xl font-semibold text-md flex items-center justify-center gap-3 transition-all duration-300 shadow-lg hover:shadow-orange-300"
                    >
                      {isLoading ? "Submitting..." : "Book Appointment"}

                      {!isLoading && <ArrowRight size={20} />}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
